export default {"src":"/_next/static/media/star-icon.877def3e.svg","height":28,"width":28};